import { render, staticRenderFns } from "./verificarDados.vue?vue&type=template&id=463d5b94&"
import script from "./verificarDados.vue?vue&type=script&lang=js&"
export * from "./verificarDados.vue?vue&type=script&lang=js&"
import style0 from "./verificarDados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports